/**
 * Tests whether a url is absolute or not.
 *
 * Currently only tests the first four characters are 'http'.
 *
 * @param {string} url
 *    URL to test.
 * @returns {bool}
 *    Whether the URL is an absolute URL or not.
 */
export function isAbsoluteURL(url) {
  return url.substr(0, 4) === 'http'
}